import { render, staticRenderFns } from "./APPmanagement.vue?vue&type=template&id=5de95c1c&scoped=true"
import script from "./APPmanagement.vue?vue&type=script&lang=js"
export * from "./APPmanagement.vue?vue&type=script&lang=js"
import style0 from "./APPmanagement.vue?vue&type=style&index=0&id=5de95c1c&prod&lang=scss"
import style1 from "./APPmanagement.vue?vue&type=style&index=1&id=5de95c1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5de95c1c",
  null
  
)

export default component.exports